import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

import styles from "../../App.module.css";
import stylesVisitor from "./visitor.module.css";
import api from "../../api/axios";
import { NotificationContainer } from "react-notifications";
import notifications from "../../components/notifications";
import { isAuthenticated } from "../../index";
import { useClienteData } from "../../components/Clientes/ClienteData";

function HomeVisitor() {
  const { clienteID } = useParams(); // ✅ vem da rota /home/:clienteID
  // hooks
  const { authenticated, userPermission, userStatus, timestamp, userLogin, userId, userNome } = isAuthenticated();
  const [notificationType, setNotificationType] = useState(0);
  const cliente = useClienteData(clienteID);
  const [agendamentos, setAgendamentos] = useState([]);
  const [loadingAgend, setLoadingAgend] = useState(false);
  const [verTodosAgendamentos, setVerTodosAgendamentos] = useState(false);


  // ✅ Hook 1
  useEffect(() => {
    if (notificationType && notifications[notificationType]) {
      notifications[notificationType]();
      setNotificationType(0);
    }
  }, [notificationType]);

  // ✅ Hook 2 (antes de qualquer return!)
  useEffect(() => {
    if (!clienteID) return;

    const fetchAgendamentos = async () => {
      setLoadingAgend(true);
      try {
        const res = await api.get(`/AgendamentosClient/${clienteID}`);
        console.log("res.data")
        console.log(res.data)
        setAgendamentos(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        console.error("Erro ao buscar agendamentos do cliente:", err);
        setAgendamentos([]);
      } finally {
        setLoadingAgend(false);
      }
    };

    fetchAgendamentos();
  }, [clienteID]);


  const formatarData = (dateLike) => {
    if (!dateLike) return "--/--/----";
    const d = new Date(dateLike);
    return Number.isNaN(d.getTime()) ? "--/--/----" : format(d, "dd/MM/yyyy");
  };

  const formatarHora = (h) => {
    if (!h) return "--:--";
    if (typeof h === "string" && h.length >= 5) return h.slice(0, 5);
    return String(h);
  };

  const proximo = agendamentos?.[0];

  // ✅ AGORA SIM: returns condicionais depois de todos hooks
  if (!cliente) {
    return (
      <div className={styles.app}>
        <div className={styles.cadastroClienteContainer}>
          <p>Carregando dados do cliente...</p>
        </div>
        <NotificationContainer />
      </div>
    );
  }


  const toDateTime = (item) => {
    // Preferência: usar `data` (datetime completo) se vier
    if (item?.data) {
      const d = new Date(item.data);
      if (!Number.isNaN(d.getTime())) return d;
    }

    // Fallback: junta dataDia + dataHorario
    const dia = item?.dataDia ? new Date(item.dataDia) : null;
    if (!dia || Number.isNaN(dia.getTime())) return null;

    const horario = (item?.dataHorario || "00:00:00").slice(0, 8);
    const [hh, mm, ss] = horario.split(":").map((n) => parseInt(n, 10) || 0);

    const d = new Date(dia);
    d.setHours(hh, mm, ss, 0);
    return d;
  };

  const getIconByTipo = (tipoRaw) => {
    const t = String(tipoRaw || "").toLowerCase();
    if (t.includes("trein")) return "treino.png";
    return "perfil.png"; // padrão (análise)
  };


  const agora = new Date();

  // normaliza + ordena crescente (mais próximo primeiro)
  const agendamentosOrdenados = (Array.isArray(agendamentos) ? agendamentos : [])
    .map((a) => ({ ...a, __dt: toDateTime(a) }))
    .filter((a) => a.__dt && !Number.isNaN(a.__dt.getTime()))
    .sort((a, b) => a.__dt - b.__dt);

  // só futuros (próximos)
  const proximosAgendamentos = agendamentosOrdenados.filter((a) => a.__dt >= agora);

  // quantos mostrar no preview (ajuste aqui)
  const LIMITE_PREVIEW = 2;

  const agendamentosParaMostrar = verTodosAgendamentos
    ? agendamentosOrdenados
    : proximosAgendamentos.slice(0, LIMITE_PREVIEW);


  const isAgendamentoPassado = (ag) => {
    // Usa o datetime completo se existir
    if (ag?.data) {
      const d = new Date(ag.data);
      return d < new Date();
    }

    // Fallback: junta dataDia + dataHorario
    if (ag?.dataDia && ag?.dataHorario) {
      const dia = new Date(ag.dataDia);
      const [hh, mm, ss] = ag.dataHorario.split(":").map(Number);
      dia.setHours(hh || 0, mm || 0, ss || 0, 0);
      return dia < new Date();
    }

    return false;
  };

  const hojeFormatado =
    format(new Date(), "dd MMMM", { locale: ptBR })
      .replace(/^\d+\s/, (m) => m)
      .replace(/^\d+\s\w/, (l) => l.toUpperCase());



  return (
    <div className={styles.app}>
      <div className={styles.cadastroClienteContainer}>
        <div className={stylesVisitor.clientePageContainer}>
          <div className={stylesVisitor.clientePageTop}>
            <div className={stylesVisitor.clientePageHeader}>
              <h1 className={stylesVisitor.clientePageName} style={{ fontSize: "1.0rem" }}>
                {hojeFormatado}
              </h1>
            </div>
          </div>
          {/* Nome + endereço */}
          <div className={stylesVisitor.clientePageHeader}>
            <h1 className={stylesVisitor.clientePageName} style={{ color: "var(--corPrimaria)" }}>Oi, {cliente.Nome}</h1>
            <p>Pronto para agilizar o seu visto?</p>
          </div>
          {/* Appointment título */}
          <div className={stylesVisitor.clientePageSectionTitle}>
            <span className={stylesVisitor.clientePageSectionLeft}>Agendamentos</span>
            <button
              type="button"
              className={stylesVisitor.clientePageSectionRight}
              onClick={() => setVerTodosAgendamentos((v) => !v)}
              style={{ background: "transparent", border: "none", cursor: "pointer" }}
            >
              {verTodosAgendamentos ? "Mostrar próximos" : "Ver todos"}
            </button>
          </div>
          {/* ✅ Lista de cards dinâmica */}
          {loadingAgend ? (
            <div className={stylesVisitor.clientePageAppointmentCard}>
              <div className={stylesVisitor.clientePageAppointmentLeft}>
                <div className={stylesVisitor.clientePageAppointmentInfo}>
                  <span className={stylesVisitor.clientePageAppointmentInfoSmall}>Carregando...</span>
                  <span className={stylesVisitor.clientePageAppointmentInfoTitle}>AGUARDE</span>
                </div>
              </div>
              <div className={stylesVisitor.clientePageAppointmentHour}>--:--</div>
            </div>
          ) : agendamentosOrdenados.length === 0 ? (
            <div className={stylesVisitor.clientePageAppointmentCard}>
              <div className={stylesVisitor.clientePageAppointmentLeft}>
                <div className={stylesVisitor.clientePageAppointmentInfo}>
                  <span className={stylesVisitor.clientePageAppointmentInfoSmall}>
                    Nenhum agendamento
                  </span>
                  <span className={stylesVisitor.clientePageAppointmentInfoTitle}>
                    AINDA NÃO AGENDADO
                  </span>
                </div>
              </div>
              <div className={stylesVisitor.clientePageAppointmentHour}>--:--</div>
            </div>
          ) : agendamentosParaMostrar.length === 0 ? (
            // tem histórico, mas não tem próximos
            <div className={stylesVisitor.clientePageAppointmentCard}>
              Nenhum agendamento encontrado
            </div>
          ) : (
            agendamentosParaMostrar.map((ag) => {
              const passado = isAgendamentoPassado(ag);
              return (
                <div
                  key={ag.id}
                  className={stylesVisitor.clientePageAppointmentCard}
                  style={{
                    backgroundColor: passado ? "#686868ff" : "var(--corPrimaria)",
                    opacity: passado ? 0.85 : 1
                  }}
                >
                  <div className={stylesVisitor.clientePageAppointmentLeft}>
                    {/* <div className={stylesVisitor.clientePageAppointmentIconBox}>
                      <img
                        src={ag.tipo?.toLowerCase().includes("trein") ? "treino.png" : "perfil.png"}
                        alt="Calendário"
                        className={stylesVisitor.clientePageAppointmentIcon}
                      />
                    </div> */}
                    <div className={stylesVisitor.clientePageAppointmentInfo}>
                      <span className={stylesVisitor.clientePageAppointmentInfoSmall}>
                        {formatarData(ag.dataDia)}
                      </span>
                      <span className={stylesVisitor.clientePageAppointmentInfoTitle}>
                        {ag.tipo.toUpperCase()}
                      </span>
                    </div>
                  </div>
                  <div className={stylesVisitor.clientePageAppointmentHour}>
                    {formatarHora(ag.dataHorario)}
                  </div>
                </div>
              );
            })
          )}
          {/* Services título */}
          <div className={stylesVisitor.clientePageSectionTitle}>
            <h1 className={stylesVisitor.clientePageName} style={{ color: "var(--corPrimaria)" }}>Contratar Serviços</h1>
            <span className={stylesVisitor.clientePageSectionRight}>Ver todos</span>
          </div>
          {/* Services list */}
          <div className={stylesVisitor.clientePageServicesList}>
            <div className={stylesVisitor.dashboardgrid}>
              {/* COLUNA ESQUERDA */}
              <div className={stylesVisitor.dashboardcolumn}>
                <div
                  className={`${stylesVisitor.dashboardcard} ${stylesVisitor.h240}`}
                  style={{ background: "linear-gradient(135deg, #3350a0ff, var(--corPrimaria))" }}
                >
                  <img
                    src="/icons/contact-form.png"
                    alt="Formulários"
                    style={{ width: 48, height: 48 }}
                  />
                  Formularios
                </div>
                <div
                  className={`${stylesVisitor.dashboardcard} ${stylesVisitor.h180}`}
                  style={{ background: "linear-gradient(135deg, #3e9bacff, #05b8c5ff)" }}
                >
                  <img
                    src="/icons/contact-form.png"
                    alt="Análise de Perfil"
                    style={{ width: 48, height: 48 }}
                  />
                  Analise de Perfil
                </div>
              </div>
              {/* COLUNA DIREITA */}
              <div className={stylesVisitor.dashboardcolumn}>
                <div
                  className={`${stylesVisitor.dashboardcard} ${stylesVisitor.h180}`}
                  style={{ background: "#da6f18ff", border: "4px solid #da6f18ff" }}
                >
                  <img
                    src="/icons/contact-form.png"
                    alt="Antecipação"
                    style={{ width: 48, height: 48 }}
                  />
                  Antecipacao
                </div>
                <div
                  className={`${stylesVisitor.dashboardcard} ${stylesVisitor.h180}`}
                  style={{ background: "linear-gradient(135deg, #2f5f9f, #6fa9d6)" }}
                >
                  <img
                    src="/icons/contact-form.png"
                    alt="Treinamento"
                    style={{ width: 48, height: 48 }}
                  />
                  Treinamento
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <NotificationContainer />
    </div>
  );
}

export default HomeVisitor;
